import { EventEmitter, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbCalendar, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { EventMantenedorCategoriaService } from 'src/app/services/event-mantenedor-categoria.service';
import { EmpresasService } from 'src/app/services/empresas.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
export class CustomAdapter extends NgbDateAdapter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '-';
    }
    fromModel(value) {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    toModel(date) {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
    }
}
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '/';
    }
    parse(value) {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    format(date) {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
    }
}
export class PlanificacionModalComponent {
    constructor(fb, eventMantenedorCategoriaService, empresasService, configurationService, ngbCalendar, dateAdapter) {
        this.fb = fb;
        this.eventMantenedorCategoriaService = eventMantenedorCategoriaService;
        this.empresasService = empresasService;
        this.configurationService = configurationService;
        this.ngbCalendar = ngbCalendar;
        this.dateAdapter = dateAdapter;
        this.createEdit = new EventEmitter();
        this.accept = new EventEmitter();
        this.reject = new EventEmitter();
        this.categoria = {
            categoriaId: null,
            codigo: "",
            descripcion: "",
            fechaInicio: "",
            fechaTermino: "",
            empresas: [],
            estado: true
        };
        this.categorias = [];
        this.errors = {
            codigo: false,
            descripcion: false,
            fechaInicio: false,
            fechaTermino: false,
            empresa: false,
            estado: false
        };
        this.flags = {
            ejecutor: false,
            relator: false,
            duracionTeorica: false,
            duracionPractica: false,
            fechaEjecucionReal: false,
            Evidencia: false,
            AsignacionParticipantes: false,
            Guardar: false
        };
        this.isRead = false;
        this.flagPassword = false;
        this.showBar = false;
        this.isReadOnEdit = false;
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.loading = false;
        this.error = false;
        this.errorMessage = '';
        this.listClass = false;
        this.flagZona = false;
        this.empresas = [];
    }
    ngOnInit() {
        let fi = this.categoria.fechaInicio.split("-");
        let ft = this.categoria.fechaTermino.split("-");
        this.startDate = { year: Number(fi[2]), month: Number(fi[1]), day: Number(fi[0]) };
        this.finishDate = { year: Number(ft[2]), month: Number(ft[1]), day: Number(ft[0]) };
        this.dp1.focus = this.startDate;
        this.obtenerEmpresas();
        this.selectedIdEmpresa = this.categoria.empresas.length > 0 ? Object.values(this.categoria.empresas).map(value => Number(value)) : [];
        console.log(this.selectedIdEmpresa, "selectedIdEmpresa");
    }
    obtenerEmpresas() {
        this.empresasService.obtenerEmpresas()
            .then(response => {
            this.empresas = response;
            this.empresas.push("Todas");
        })
            .catch(error => {
            error = true;
        });
    }
    getLabel(value, defaultValue) {
        return value ? value.toString() : defaultValue;
    }
    changeInput(field, value, type = '') {
        if (field === 'estadoId') {
            if (value === 'true') {
                this.categoria.estado = true;
            }
            else {
                this.categoria.estado = false;
            }
        }
        this.categoria[field] = value;
    }
    onSave(send = false) {
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        if (this.isValid()) {
            this.loading = true;
            if (this.mode === 'Editar') {
                const categoria = this.categoria;
                const request = {
                    idPlanificacion: categoria.categoriaId,
                    codigoPlanificacion: categoria.codigo,
                    descripcion: categoria.descripcion,
                    fechaInicio: categoria.fechaInicio,
                    fechaTermino: categoria.fechaTermino,
                    usuarioId: Number(sessionStorage.getItem('userid')),
                    empresas: this.categoria.empresas,
                    statusPlanificacion: categoria.estado
                };
                this.configurationService.update(request)
                    .then(response => {
                    this.createEdit.emit();
                    this.eventMantenedorCategoriaService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
            else {
                const categoria = this.categoria;
                const request = {
                    codigoPlanificacion: categoria.codigo,
                    descripcion: categoria.descripcion,
                    fechaInicio: categoria.fechaInicio,
                    fechaTermino: categoria.fechaTermino,
                    usuarioId: Number(sessionStorage.getItem('userid')),
                    empresas: this.categoria.empresas,
                };
                this.configurationService.create(request)
                    .then(response => {
                    this.createEdit.emit();
                    this.eventMantenedorCategoriaService.refreshTable();
                    this.loading = false;
                    this.modalCategoria.dismiss('Cancel');
                })
                    .catch(error => console.error(error));
            }
        }
    }
    isValid() {
        let isValid = true;
        const isCodigoValid = this.categoria.codigo && this.categoria.codigo.length <= 50;
        isValid = isValid ? isCodigoValid : false;
        this.errors.codigo = !isCodigoValid;
        const isDescripcionValid = this.categoria.descripcion && this.categoria.descripcion.length <= 100;
        isValid = isValid ? isDescripcionValid : false;
        this.errors.descripcion = !isDescripcionValid;
        const isFechaInicioValid = this.categoria.fechaInicio && String(this.categoria.fechaInicio) != "";
        isValid = isValid ? isFechaInicioValid : false;
        this.errors.fechaInicio = !isFechaInicioValid;
        const isFechaTerminoValid = this.categoria.fechaTermino && String(this.categoria.fechaTermino) != "" && this.dateCompare(this.categoria.fechaInicio, this.categoria.fechaTermino) == true;
        isValid = isValid ? isFechaTerminoValid : false;
        this.errors.fechaTermino = !isFechaTerminoValid;
        const isEmpresaValid = this.selectedIdEmpresa && this.selectedIdEmpresa.lenght != 0;
        isValid = isValid ? isEmpresaValid : false;
        this.errors.empresa = !isEmpresaValid;
        if (this.mode == 'Editar') {
            const isEstadoIdValid = this.categoria.estado != null;
            isValid = isValid ? isEstadoIdValid : false;
            this.errors.estado = !isEstadoIdValid;
        }
        if (!this.errors.fechaInicio) {
            this.categoria.fechaInicio = String(this.categoria.fechaInicio);
        }
        else {
            this.categoria.fechaInicio = "";
        }
        if (!this.errors.fechaTermino) {
            this.categoria.fechaTermino = String(this.categoria.fechaTermino);
        }
        else {
            this.categoria.fechaTermino = "";
        }
        if (!this.errors.empresa) {
            this.categoria.empresas = this.selectedIdEmpresa;
        }
        else {
            this.categoria.empresas = [];
        }
        return isValid;
    }
    dateCompare(d1, d2) {
        var algo = d1.replaceAll('-', '/');
        var algo2 = d2.replaceAll('-', '/');
        var fecha1 = algo.split('/');
        var fecha2 = algo2.split('/');
        const date1 = new Date(fecha1[2], fecha1[1], fecha1[0]);
        const date2 = new Date(fecha2[2], fecha2[1], fecha2[0]);
        console.log(date2, date1);
        if (date1 > date2) {
            return false;
        }
        else if (date1 <= date2) {
            return true;
        }
        else {
            console.log(`Both dates are equal`);
        }
    }
}
